<template>
  <main class="express-registration h-screen">
    <header
      v-if="!('name' in $route.meta && $route.meta.name === 'ibpp')"
      :class="$route.meta.hasLogo && 'registration__header--custom-logo'"
      class="registration__header"
    >
      <dr-vector
        fill="blue"
        :src="logo"
      />

      <img
        v-if="$route.meta.hasLogo"
        :src="require(`@/assets/img/custom-registration-logos/${$route.meta.image}`)"
      />
    </header>

    <header
      v-else
      class="registration__header registration__header--ibpp"
    >
      <img
        v-if="$route.meta.hasLogo"
        :src="require(`@/assets/img/custom-registration-logos/${$route.meta.image}`)"
      />
    </header>

    <transition-group name="fade">
      <div
        v-if="currentStep === 1"
        key="1"
        class="express-registration__router-view"
      >
        <article class="express-registration">
          <form
            v-if="loaded"
            class="express-registration__form"
            @submit.prevent="submit()"
          >
            <dr-field
              v-for="(field, name) in formData"
              :key="'main_'+name"
              :ref="name"
              :id="name"
              :form.sync="formData"
              :field="field"
              :validators.sync="$v.formData[name]"
              :apiErrors.sync="apiErrors[name]"
              :wrap="field.wrap"
              prefix="form1"
              :class="field.class"
              class="text-left express-registration__form-field"
              @changed="queryCrm()"
            />

            <p
              v-if="$v.$invalid && sending"
              class="express-registration__warning text-warning col-12 text-center"
            >
              Por favor complete o formulário corretamente
            </p>

            <div
              :class="($v.tos.$invalid && sending) && 'has-error'"
              class="express-registration__tos"
            >
              <label class="form-checkbox">
                <input
                  v-model="tos"
                  type="checkbox"
                >

                <i class="form-icon" />
                Eu concordo com os
                <a @click="showTos($event)">termos de uso</a>
              </label>
            </div>

            <footer
              v-if="('name' in $route.meta && $route.meta.name === 'ibpp')"
              key="registration-footer"
              class="registration__footer registration__footer--ibpp"
            >
              <img src="@/assets/img/home/logo_web.png" class="login__logo login__logo--ibpp" />
            </footer>

            <div class="express-registration__footer">
              <dr-submit
                :disabled="$v.$invalid"
                :sending="sending"
                text="Cadastrar gratuitamente"
              />

              <a
                class="btn btn-transparent"
                @click="$router.push('/')"
              >
                Fazer login
              </a>
            </div>

            <!-- Não mostra pois v-if=false -->
            <div
              v-if="false"
              class="express-registration__help"
            >
              <dr-help
                v-if="localActive"
                @closeHelp="close()"
              />

              <div class="express-registration__help__btn">
                <a
                  class="btn btn-help"
                  @click="localActive = !localActive"
                >
                  Ajuda

                  <dr-icon
                    name="help"
                    fill="#ffffff"
                    color="#ffffff"
                  />
                </a>
              </div>
            </div>
          </form>
        </article>
      </div>

      <div
        v-if="currentStep === 2"
        key="3"
        class="express-registration__success"
      >
        <p class="express-registration__success-text express-registration__success-text--strong">
          Enviamos um link de confirmação para o seu e-mail.
        </p>

        <p class="express-registration__success-text">
          Confirme seu e-mail e comece a usar todos os benefícios
          do Dr. Conecta para o seu consultório.
        </p>

        <router-link to="/login" class="btn btn-primary">
          Efetuar login
        </router-link>
      </div>
    </transition-group>
  </main>
</template>

<script>
import { formData, validations } from '@/data/formData/simpleRegistration'
import { sameAs } from 'vuelidate/lib/validators'
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import drHelp from '@/components/form/help'
import tos from '@/data/miscData/tos'
import logo from '@/assets/img/logo-branco.svg'
// import googleLogin from '@/components/form/googleLogin'
// import selectPlan from '@/components/layout/plans/select'

export default {
  name: 'DrSimpleRegistration',

  components: {
    drField,
    drSubmit,
    drHelp
    // selectPlan
    // googleLogin
  },

  validations: {
    formData: validations,

    tos: {
      checked: sameAs(function () { return true })
    }
  },

  data () {
    return {
      formData,
      logo,
      tos: false,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      sending: false,
      currentStep: 1,
      loaded: false,
      user: null,
      currentTransition: 'fade_left',
      localActive: '',
      features: null,
      plans: null,
      uuid: null,
      medicalSpecialties: null,
      previousCrm: null,
      previousUf: null
    }
  },

  computed: {
    ddi () {
      return this.formData['user.ddiContactPhone'].value
    }
  },

  watch: {
    ddi: {
      deep: false,
      immediate: false,
      handler (next, before) {
        if (next !== before) {
          const { mask, placeholder } = this.formData['user.ddiContactPhone'].options.find(
            (option) => option.id === this.formData['user.ddiContactPhone'].value
          )

          this.formData['user.contactPhone'].placeholder = placeholder
          this.formData['user.contactPhone'].mask = [mask]

          if (this.formData['user.ddiContactPhone'].value === 'br') {
            this.formData['user.contactPhone'].mask = ['(##) ####-####', '(##) #####-####']
          }
        }
      }
    }
  },

  created () {
    if (document.domain === 'medico.drconecta.com.br') {
      window.fbq('init', '532918017596757')
      window.fbq('track', 'DoctorStartRegistration')
    }

    this.formData['user.ddiContactPhone'].value = 'br'
  },

  mounted () {
    this.features = this.PLANS_DATA.features
    this.plans = this.PLANS_DATA.plans

    this.fn_SHOW_PROGRESS()
    this.getMedicalSpecialties()
      .then(() => (this.loaded = true))
      .finally(() => this.fn_HIDE_PROGRESS())

    this.toggleCrmFields(true, ['medicalSpecialty'])

    if ('fn' in this.$route.meta) {
      this.$route.meta.fn(this.$route.params, this)
    }
  },

  destroyed () {
    for (let field in this.formData) {
      this.formData[field].value = null
    }
  },

  methods: {
    close (v) {
      this.localActive = v
    },

    showTos (event) {
      event.stopPropagation()
      event.preventDefault()

      this.$store.dispatch('setModalAlert', {
        title: 'Termos de uso',
        body: tos,
        size: 'lg',
        active: true
      })
    },

    submit () {
      this.apiErrors = this.fn_BUILD_API_ERRORS(formData)
      this.sending = true
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.sending = false
        return
      }

      let data = this.fn_COPY_OBJECT(this.formData)
      data['user.contactPhone'].value = this.fn_NUMBERS_ONLY(data['user.contactPhone'].value)
      data = this.fn_EXPAND_OBJECT(data)
      data['hasTermsOfUse'] = this.tos ? 1 : 0
      data.crmRegional = this.formData.crmRegional.options
        .find(uf => uf.id === this.formData.crmRegional.value)
        .name

      if (parseInt(data.isCfmValidation) === 0) {
        data.medicalSpecialty = this.medicalSpecialties
          .find(i => parseInt(i.id) === parseInt(data.medicalSpecialty))
          .name
      } else {
        if (Array.isArray(this.formData['medicalSpecialty'].value)) {
          data.medicalSpecialty = this.formData['medicalSpecialty'].value
            .map(i => String(i).trim())
            .join(', ')
        }
      }

      // Clean CPF
      data.user.cpf = data.user.cpf.replace(/\D/gi, '')

      data.user.ddiContactPhone = this.formData['user.ddiContactPhone'].options
        .find((option) => option.id === data.user.ddiContactPhone)
        .code

      this.fn_SHOW_PROGRESS()
      this.$http
        .post('/doctor/register', { 'register': data })
        .then((res) => {
          this.uuid = res.data[1]
          this.currentStep = 2

          // Facebook tracking code
          window.fbq('init', '532918017596757')
          window.fbq('track', 'DoctorFinishRegistration')

          // data = {
          //   _username: this.formData['user.email.first'].value,
          //   _password: this.formData['user.plainPassword.first'].value
          // }
          // this.$http.post('/login_check', data).then(
          //   (res) => {
          //     this.$store.dispatch('setAuth', res.data)
          //     this.$router.push('/doctor')
          //     this.fn_HIDE_PROGRESS()
          //   }
          // ).catch(
          //   (err) => {
          //     console.log(err)
          //     this.sending = false
          //     this.fn_HIDE_PROGRESS()
          //     this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          //   }
          // )
        })
        .catch(err => this.handleError(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.sending = false
        })
    },

    queryCrm () {
      const { crm, crmRegional, medicalSpecialty, isCfmValidation } = this.formData

      if (
        crm.value &&
        crmRegional.value &&
        (
          this.previousCrm !== crm.value ||
          this.previousUf !== crmRegional.value
        )
      ) {
        const ufString = crmRegional.options.find(item => item.id === crmRegional.value).name
        const endpoint = `/cfm/doctor?crm=${crm.value}&uf=${ufString}`

        medicalSpecialty.value = null
        crm.loading = 1
        medicalSpecialty.loading = 1

        this.fn_SHOW_PROGRESS()

        this.checkIfCfmIsOnline()
          .then(() => this.$http.get(endpoint, this.$store.getters.getAuthHeader))
          .then((res) => {
            const { dadosMedico } = res.data

            if (!dadosMedico.especialidade) {
              // Médico sem especialidade cadastrada. Carrega opções da base Dr. Conecta
              this.toggleCrmFields(false, ['medicalSpecialty'])
              medicalSpecialty.options = this.medicalSpecialties
              isCfmValidation.value = 0
              return
            }

            // Médico com especialidade cadastrada. Carrega o valor recebido
            // e mantém o campo especialidade médica bloqueado
            this.toggleCrmFields(true, ['medicalSpecialty'])
            isCfmValidation.value = 1
            medicalSpecialty.type = 'text'
            medicalSpecialty.value = dadosMedico.especialidade
          })
          .catch((err) => {
            console.log('err is', err)
            if (
              typeof err === 'object' &&
              'message' in err &&
              err.message === 'Api fora do ar'
            ) {
              // Api do CFM fora do ar
              this.toggleCrmFields(false, ['medicalSpecialty'])
              medicalSpecialty.options = this.medicalSpecialties
              isCfmValidation.value = 0
            }

            if (err === 'Médico não está ativo') {
              // Médico com restrição ou CRM inválido
              this.toggleCrmFields(true, ['medicalSpecialty'])

              this.$store.dispatch('setModalAlert', {
                title: 'Erro',
                body: 'O CRM não é valido ou possui algum tipo de restrição. Por favor entre em contato conosco.',
                size: 'md',
                active: true
              })
            }
          })
          .finally(() => {
            crm.loading = 2
            medicalSpecialty.loading = 2
            this.fn_HIDE_PROGRESS()
          })

        this.previousCrm = crm.value
        this.previousUf = crmRegional.value
      }
    },

    toggleCrmFields (disabled = true, fields = ['crm', 'uf', 'medicalSpecialty']) {
      for (let field of fields) {
        this.formData[field].disabled = disabled
      }
    },

    checkIfCfmIsOnline () {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/cfm/doctor?crm=104372&uf=SP`, this.$store.getters.getAuthHeader)
          .then(resolve)
          .catch(() => reject(new Error('Api fora do ar')))
      })
    },

    getMedicalSpecialties () {
      return this.$http
        .get('/medical_specialty?itensPerPage=all')
        .then((res) => {
          this.medicalSpecialties = res.data.data
            .map((specialty) => {
              return {
                id: specialty.id,
                name: this.capitalizeString(specialty.name)
              }
            })
        })
    },

    capitalizeString (str) {
      return str.toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.substring(1))
        .join(' ')
    },

    sanitizeString (str) {
      return str.split(' - ')[0].trim()
    },

    findErrorMessage (object) {
      let errorMessage = []

      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage.push(object[value])
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }

      if (Array.isArray(object)) {
        object.forEach((element) => {
          if (typeof element === 'object') {
            recursiveSearch(element)
          } else {
            errorMessage.push(element)
          }
        })
      } else {
        recursiveSearch(object)
      }

      return errorMessage
    },

    handleError (err) {
      let msgArray = null

      switch (true) {
        case (typeof err === 'object' && 'errors' in err):
          msgArray = this.findErrorMessage(err.errors)
          break

        case (typeof err === 'string'):
          msgArray = [err]
          break

        default:
          msgArray = ['Ocorreu um erro']
      }

      let errorMsg = null

      for (let msg of msgArray) {
        if (Array.isArray(msg)) {
          if (msg.some((i) => /alreadyinuse/gi.test(i))) {
            const errorObj = JSON.parse(
              msg
                .find((j) => /alreadyinuse/gi.test(j))
                .replace('alreadyInUse:', '')
            )

            if (errorObj.role.some((role) => /doctor/gi.test(role))) {
              errorMsg = msg[0]
              break
            }

            errorMsg = { uuid: errorObj.uuid, email: errorObj.email }
          }
        } else {
          errorMsg = msg
        }
      }

      if (typeof errorMsg === 'object') {
        this.showDoctorConfirmation(errorMsg)
        return
      }

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: errorMsg,
        size: 'md',
        active: true
      })
    },

    showDoctorConfirmation ({ uuid = null, email = null } = {}) {
      const alert = {
        title: 'Atenção',
        body: `Percebemos que você já está cadastrado em nossa
          plataforma de pacientes. Deseja receber um e-mail em
          <strong>${email}</strong> para prosseguir seu cadastro
          como médico?`,
        size: 'md',
        active: true,
        cancelText: 'Cancelar',
        confirmText: 'Continuar cadastro',
        beforeClose: (v) => {
          if (v) {
            this.sendDoctorConfirmationEmail(uuid)
          }

          this.$store.dispatch('setModalConfirm')
        }
      }

      this.$store.dispatch('setModalConfirm', alert)
    },

    sendDoctorConfirmationEmail (uuid) {
      const url = `/doctor/register/user/${uuid}/send_confirmation_email`

      this.fn_SHOW_PROGRESS()

      this.$http.post(url)
        .then((res) => {
          if (res) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: `As instruções para finalização do cadastro
                foram enviadas com sucesso para o seu e-mail.`,
              size: 'md',
              active: true
            })

            this.$router.push('/')
          }
        })
        .catch(this.handleError)
        .finally(this.fn_HIDE_PROGRESS)
    }

    // changePlan (ev) {
    //   if (!ev.selectedPlan || ev.selectedPlan === 1) {
    //     this.currentStep = 3
    //     return
    //   }
    //   this.fn_SHOW_PROGRESS()
    //   this.$http.post(`/doctor/${this.uuid}/register/doctor_subscription_plan`, {subscription_plan: { id: ev.selectedPlan }}).then(
    //     (res) => {
    //       this.currentStep = 3
    //       this.fn_HIDE_PROGRESS()
    //     }
    //   ).catch(
    //     (err) => {
    //       console.log(err)
    //     }
    //   )
    // }
  }
}
</script>
